import {FooterTabFragment, FooterTabFragmentProps, FooterTabFragmentState} from "../shared/FooterTabFragment";
import {ReactElement} from "react";

export abstract class BaseAppTabFragment<P extends FooterTabFragmentProps = FooterTabFragmentProps, S extends FooterTabFragmentState = FooterTabFragmentState> extends FooterTabFragment<P, S> {

  renderContent(): ReactElement {
    return this.renderTabContent();
  }

  abstract renderTabContent(): ReactElement;
}